module.exports = __webpack_public_path__ + "static/media/sell_request_details_help_3-3.854b7f5f.png";